<template>
  <div
    :id="this.id"
    @contextmenu.prevent="handler($event)"
    class="sitebuilder-element-container"
    element="GetResponseFormComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    v-on:click="focusElement($event)"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize"
      :draggable="false"
      ref="draggableResizable"
    >
      <sync-drag :target="this"/>

      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-GetResponseFormComponent'>
        <img class="svg-icon normal-action"
             src="static/images/icons/engrenagem.svg"
             v-tooltip="{content:$t('ct-option-set-list'),  class: 'tooltip-custom'}"
             @click="configure()"
        />
        <img
          class="svg-icon normal-action"
          src="static/images/icons/recaptcha.svg"
          v-tooltip="{content:$t('ct-option-set-recaptcha'),  class: 'tooltip-custom'}"
          @click="openModalRecaptcha()"
        />
      </options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>

      <form
        class="form-getresponse" :class="horizontal ? 'horizontal-form': ''"
        :id="internal_config.listUid"
        method="post"
        ref="form"
      >
        <div class="inputs-area" ref="container"></div>

        <div class="recaptcha-container" v-if="internal_config.recaptchaSiteKey">
          <vue-recaptcha :sitekey="internal_config.recaptchaSiteKey"></vue-recaptcha>
        </div>

        <div class="place-btn">
          <div class="bt-sb"
               v-bind:style="{
                width : buttonWidth,
                border : buttonBorder,
                'border-radius': buttonRadius,
                background: buttonBackground,
                'box-shadow': buttonBoxShadow
               }">
            <div class="btn-text-area"
                 v-bind:style="{minHeight: buttonHeight}">
              <a v-on:click="submit($event)" class="sb-text"
                 :style="textStyle()">{{ internal_config.button.text }}</a>
              <small class="sb-sub-text" v-show="internal_config.button.subText != ''"
                     :style="subTextStyle()">{{ internal_config.button.subText }}</small>
            </div>
          </div>
        </div>

      </form>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>

  </div>
</template>

<script>
import Vue from 'vue';
import Data from './Model';
import Resources from './Resources.vue';

import {
  submitForm
} from '../../../../../js/services/editor/getresponse';
import CheckFields from '../Fields/CheckFields.vue';
import SelectFields from '../Fields/SelectFields.vue';
import TextFields from '../Fields/Text.vue';
import DateFields from '../Fields/DateFields.vue';
import OptionsElementBar from '../../OptionsElementBar';
import VueRecaptcha from 'vue-recaptcha';
import ReCaptcha from '../../../resources/ReCaptcha';

export default {
  name: 'GetResponseFormComponent',
  props: ['config', 'id', 'preview'],
  components: {
    OptionsElementBar,
    Resources,
    VueRecaptcha,
    ReCaptcha
  },
  computed: {
    action() {
      return this.internal_config.action;
    },
    horizontal() {
      return this.internal_config.horizontal;
    },
    buttonWidth() {
      return parseInt(this.internal_config.button.width) + '%';
    },
    buttonHeight() {
      return parseInt(this.internal_config.button.height) + 'px';
    },
    buttonBorder() {
      return this.internal_config.button.border;
    },
    buttonBoxShadow() {
      return this.internal_config.button.boxShadow;
    },
    buttonRadius() {
      return this.internal_config.button.borderRadius;
    },
    buttonBackground() {
      let bg = this.internal_config.button.backgroundColor;

      if (
        this.internal_config.backgroundImage !== 'none' &&
        typeof this.internal_config.backgroundImage !== 'undefined'
      ) {
        bg += ' url("' + this.internal_config.button.backgroundImage + '")';
        bg += ' ' + this.internal_config.button.backgroundPosition;
        bg += ' / ' + this.internal_config.button.backgroundSize;
        bg += ' ' + this.internal_config.button.backgroundRepeat;
        bg += ' ' + this.internal_config.button.backgroundOrigin;
      }

      return bg;
    }
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },

  methods: {
    save(config) {
      this.internal_config = Object.assign({}, this.internal_config, config);
      this.buildFields(this);
    },

    animation() {
      return true;
    },

    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    configure() {
      this.$root.$emit('openGetResponseModal', this.internal_config, this, this.save, 'config');
    },

    openModalRecaptcha() {
      this.$root.$emit('showReCaptcha', this.internal_config.recaptchaSiteKey, this.internal_config.recaptchaSecretKey, this.saveReCaptcha)
    },

    submit(e) {
      e.preventDefault();

      var formdata = $(this.$refs.form).serializeArray();
      var data = {};
      $(formdata).each(function (index, obj) {
        data[obj.name] = obj.value;
      });

      submitForm(this.internal_config.token, data, this.$refs.form.id)
        .then(res => {
          console.log(res);
        }).catch(err => {
        console.log(err);
      });
    },
    buildFields: function (vm) {
      this.$refs.container.innerHTML = '';
      vm.internal_config.fields.forEach(field => {
        var buildField = field;
        buildField.tag = field.target_field_id;
        let identifier = field.field;
        if (typeof identifier === 'undefined') {
          identifier = 'text';
        }

        if (['email', 'name'].includes(buildField.tag)) {
          buildField.essential = true;
          buildField.required = 'yes';
          buildField.visibility = 'visible';
        }

        if (identifier === 'textarea') vm.createTextField(buildField, true);
        if (identifier === 'text') vm.createTextField(buildField, false);
        if (identifier === 'password') vm.createTextField(buildField, false, true);
        if (identifier === 'select') vm.createDropDown(buildField, false);
        if (identifier === 'multiselect') vm.createDropDown(buildField, true);
        if (identifier === 'dropdown') vm.createDropDown(buildField, false);
        if (identifier === 'datetime') vm.createDateTime(buildField, true);
        if (identifier === 'date') vm.createDateTime(buildField, false);
        if (identifier === 'checkbox') vm.createCheckField(buildField, 'checkbox');
        if (identifier === 'radio') vm.createCheckField(buildField, 'radio');
      });
      $('body').removeClass('loading');
    },
    onResize: function (x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },

    buttonStyle() {
      return `
                 width : ${this.buttonWidth};
                 border : ${this.buttonBorder};
                 border-radius: ${this.buttonRadius};
                 background: ${this.buttonBackground};
                 box-shadow: ${this.buttonBoxShadow};
                 font-family: ${this.internal_config.button.textStyle.family};
                 font-size: ${this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
    },

    textStyle() {
      return `font-family:  ${this.internal_config.button.textStyle.family};
               font-size: ${this.internal_config.button.textStyle.size};
               text-align: ${this.internal_config.button.textStyle.align};
               font-weight: ${this.internal_config.button.textStyle.weight};
               font-style: ${this.internal_config.button.textStyle.style};
               color: ${this.internal_config.button.textStyle.color}`;
    },

    subTextStyle() {
      return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
    },
    buildIcon: function () {
      $(this.$el)
        .find('i')
        .detach();

      if (this.internal_config.button.icon !== '') {
        if (this.internal_config.button.iconPosition === 'left') {
          $('<i>')
            .addClass(this.$addIconPrefix(this.internal_config.button.icon))
            .prependTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
        if (this.internal_config.button.iconPosition === 'right') {
          $('<i>')
            .addClass(this.$addIconPrefix(this.internal_config.button.icon))
            .appendTo(
              $(this.$el)
                .find('.sb-text')
                .get(0)
            );
        }
      }
    },
    build(config) {
      this.internal_config = config;
      this.buildFields(this);
      this.buildIcon();
    },
    style() {
      return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                z-index: ${this.internal_config.zIndex};
                max-width: ${this.internal_config.maxWidth};
                margin: 0 auto;
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function (e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    createCheckField(field, type) {
      let ComponentClass = Vue.extend(CheckFields);
      let instance = new ComponentClass({
        propsData: {
          type: type,
          label: field.label,
          options: field.options,
          showLabel: true,
          showPlaceholder: this.internal_config.showPlaceholder,
          selected: [],
          data: field
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createDropDown(field, multiple) {
      let ComponentClass = Vue.extend(SelectFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          options: field.options,
          selected: [],
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          multiple: multiple
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createDateTime(field, useCurrent) {
      let ComponentClass = Vue.extend(DateFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          value: new Date().toString(),
          type: useCurrent ? 'datetime' : 'date'
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    createTextField(field, area) {
      let ComponentClass = Vue.extend(TextFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          value: '',
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          data: field,
          area: area
        }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    },
    inputStyle() {
      let vm = this;
      let elements = this.$el.getElementsByClassName('form-control');
      [].forEach.call(elements, function (el) {
        el.style.backgroundColor = vm.internal_config.inputBgColor;
        el.style.border = vm.internal_config.inputBorder;
        if (el.tagName === 'TEXTAREA' && vm.internal_config.textareaHeight) {
          el.style.height = vm.internal_config.textareaHeight;
          el.classList.add('form-control-textarea-has-height');
        } else {
          el.style.height = vm.internal_config.inputHeight;
        }
        el.style.borderRadius = vm.internal_config.inputRadius;

        el.style.fontFamily = vm.internal_config.inputStyle.family;
        el.style.fontSize = vm.internal_config.inputStyle.size;
        el.style.textAlign = vm.internal_config.inputStyle.align;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.color = vm.internal_config.inputStyle.color;
      });

      vm.$el.style.color = vm.internal_config.labelStyle;
    },
    saveReCaptcha(siteKey, secretKey) {
      this.internal_config.recaptchaSiteKey = siteKey;
      this.internal_config.recaptchaSecretKey = secretKey;
    }
  },

  mounted() {
    let vm = this;

    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );

    this.build(this.internal_config);
    this.internal_config.button.subText = this.internal_config.button.subtext;

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');

      this.$el.addEventListener('mouseover', function () {
        document.body.style.setProperty(
          '--button-background-color--hover',
          vm.internal_config.button.backgroundColorHover
        );
        document.body.style.setProperty(
          '--button-text-color--hover',
          vm.internal_config.button.textColorHover
        );
      });
    }

    if (typeof this.internal_config.action === undefined || this.internal_config.action == null) {
      this.internal_config.action = 'message';
    }

    if (
      this.internal_config.listUid === '' ||
      this.internal_config.token === ''
    ) {
      this.configure();
    }

    this.inputStyle();

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) {
        objIds.push(this.id);
      }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .btn-outline-success.disabled, .btn-outline-success:disabled, .btn-outline-success.disabled:hover {
    color: #ccc;
    border-color: #ccc;
    background-color: transparent;
  }

  .preview .bt-sb:hover {
    cursor: pointer;
    background-color: var(--button-background-color--hover) !important;
    color: var(--button-text-color--hover) !important;
    -webkit-text-fill-color: var(--button-text-color--hover) !important;
  }

  #getresponse-token {
    background-image: none !important;
  }

  .horizontal-form .inputs-area {
    display: flex;
    justify-content: space-between;
  }

  .btn-text-area.show-label {
    margin-top: 32px;
  }

  .sb-text {
    line-height: 25px;
  }

  .place-btn {
    text-align: center;
  }

  .btn-text-area {
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  [data-device="tablet"] .btn-text-area,
  [data-device="mobile"] .btn-text-area {
    width: auto !important;
  }

</style>

<style lang="scss">
  .form-getresponse.horizontal-form .inputs-area > div {
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/GetResponseForm/GetResponseForm.vue